import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const IndicatorWrapper = styled.div`
  word-break: break-all;
  display: flex;
  transition: opacity 0.4s ease-in-out;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  height: ${(props) => (props.isVisible ? "100%" : 0)};
  overflow: ${(props) => (props.hasError ? "hidden" : "visible")};

  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 105px;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 120px;
  }
`;

export const IconWrapper = styled.div`
  margin-right: var(--gaq-size-space-3px);
`;

export const StyledTextWrapper = styled(DhlText)`
  display: block;
  & > *:is(p, span) {
    display: block;
  }
`;

export const StyledText = styled.div`
  display: inline-block;
  padding-right: var(--gaq-size-space-3px);

  & + & {
    padding-right: var(--dui-size-space-0);
  }
`;
